var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDescontosExclusivos = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "224.612 129.472 53.644 54.6318",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23336_66054",
    x1: 10.5098,
    y1: 45.8572,
    x2: 45.7239,
    y2: 10.6431,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0739,
    stopColor: "#EC8709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2075,
    stopColor: "#EF9910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3662,
    stopColor: "#F2A616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    stopColor: "#F4AE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23336_66054",
    x1: 30.458,
    y1: 48.7517,
    x2: 41.0524,
    y2: 3.71797,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0903,
    stopColor: "#A141CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2682,
    stopColor: "#8F40B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4632,
    stopColor: "#833FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    stopColor: "#7B3F9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23336_66054",
    x1: 40.5485,
    y1: 39.7989,
    x2: 41.2564,
    y2: 36.7901,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0771,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23336_66054",
    x1: 33.1985,
    y1: 38.0698,
    x2: 33.9064,
    y2: 35.061,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0771,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23336_66054",
    x1: 25.8486,
    y1: 36.3406,
    x2: 26.5565,
    y2: 33.3318,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0771,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23336_66054",
    x1: 15.4819,
    y1: 13.64,
    x2: 26.7424,
    y2: 13.6382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0016
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1444,
    stopColor: "#040205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#0F0813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4855,
    stopColor: "#21112A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6692,
    stopColor: "#3B1F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8569,
    stopColor: "#5C3074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23336_66054",
    x1: 8.253,
    y1: 17.3587,
    x2: 16.8994,
    y2: 16.085,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7411B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC41D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_23336_66054",
    x1: 1.76432,
    y1: 19.3419,
    x2: 13.5296,
    y2: 19.3419,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7411B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC41D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_23336_66054",
    x1: 0.746875,
    y1: 18.0049,
    x2: 7.42646,
    y2: 16.0819,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7411B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC41D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_23336_66054",
    x1: 1.76422,
    y1: 17.5429,
    x2: 13.5295,
    y2: 17.5429,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 223.189255, 129.051926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E049B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7411B7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23336_66054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 4,
    width: 7,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.458 19.775L26.1912 4.14166L28.6412 5.89166L25.4912 19.425L22.458 19.775Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 251.306 182.31 C 264.998 182.31 276.098 171.111 276.098 157.297 C 276.098 143.482 264.998 132.284 251.306 132.284 C 237.614 132.284 226.514 143.482 226.514 157.297 C 226.514 171.111 237.614 182.31 251.306 182.31 Z",
    fill: "url(#paint0_linear_23336_66054)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 276.564 136.962 L 270.532 135.539 C 270.521 135.667 270.497 135.807 270.474 135.935 C 269.937 138.222 266.601 139.389 263.019 138.549 C 259.437 137.709 256.976 135.177 257.512 132.89 C 257.547 132.762 257.582 132.634 257.629 132.505 L 252.461 131.292 L 245.006 162.955 L 269.086 168.625 L 276.564 136.962 Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 241.319 173.374 L 247.339 174.785 C 247.351 174.657 247.374 174.517 247.398 174.389 C 247.934 172.102 251.271 170.935 254.853 171.775 C 258.434 172.615 260.896 175.147 260.359 177.434 C 260.324 177.562 260.289 177.69 260.243 177.819 L 265.411 179.032 L 267.954 168.24 L 243.874 162.57 L 241.319 173.374 Z",
    fill: "#FF5AAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 266.61 154.997 L 265.217 156.884 L 253.408 147.838 L 254.796 145.971 L 266.61 154.997 Z M 259.381 156.736 C 258.891 158.816 256.992 160.168 254.725 159.634 C 252.683 159.154 251.354 157.24 251.887 154.973 C 252.381 152.875 254.262 151.519 256.51 152.048 C 258.57 152.533 259.918 154.451 259.381 156.736 Z M 257.437 156.259 C 257.666 155.285 257.01 154.459 256.036 154.229 C 254.968 153.978 254.089 154.523 253.877 155.422 C 253.653 156.377 254.304 157.222 255.278 157.451 C 256.327 157.698 257.23 157.14 257.437 156.259 Z M 267.949 147.879 C 267.46 149.958 265.56 151.31 263.312 150.781 C 261.251 150.297 259.922 148.383 260.456 146.116 C 260.949 144.018 262.849 142.666 265.097 143.195 C 267.157 143.679 268.486 145.593 267.949 147.879 Z M 266.005 147.402 C 266.234 146.428 265.578 145.601 264.604 145.372 C 263.555 145.125 262.676 145.67 262.464 146.569 C 262.235 147.543 262.872 148.365 263.846 148.594 C 264.895 148.841 265.793 148.301 266.005 147.402 Z",
    fill: "#FF5AAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 267.663 181.109 L 258.866 179.044 L 258.668 178.169 C 258.189 176.092 256.603 174.505 254.526 174.015 C 252.461 173.525 250.326 174.249 248.973 175.882 L 248.401 176.57 L 239.604 174.505 L 250.198 129.472 L 258.924 131.525 L 259.123 132.435 C 259.554 134.559 261.188 136.262 263.299 136.752 C 265.411 137.242 267.628 136.46 268.958 134.745 L 269.529 134.01 L 278.256 136.075 L 267.663 181.109 Z M 261.223 176.617 L 265.504 177.62 L 274.779 138.21 L 270.614 137.23 C 268.561 139.33 265.528 140.24 262.634 139.552 C 259.741 138.875 257.431 136.705 256.533 133.917 L 252.368 132.937 L 243.093 172.347 L 247.374 173.35 C 249.428 171.344 252.344 170.515 255.191 171.192 C 258.038 171.869 260.278 173.91 261.223 176.617 Z",
    fill: "url(#paint1_linear_23336_66054)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 260.14 166.43 C 260.425 165.213 261.641 164.458 262.858 164.743 L 263.076 164.794 C 263.149 164.811 263.221 164.832 263.291 164.856 C 263.365 164.866 263.438 164.879 263.512 164.896 L 263.948 164.998 C 264.021 165.016 264.093 165.036 264.163 165.06 C 264.237 165.07 264.31 165.083 264.384 165.1 L 264.82 165.202 C 264.893 165.22 264.965 165.24 265.035 165.264 C 265.109 165.274 265.182 165.287 265.256 165.305 L 265.692 165.407 C 265.766 165.424 265.837 165.444 265.907 165.468 C 265.981 165.478 266.054 165.492 266.128 165.509 L 266.346 165.56 C 267.562 165.844 268.317 167.061 268.033 168.278 C 267.748 169.494 266.531 170.249 265.315 169.964 L 265.097 169.913 C 265.023 169.896 264.951 169.875 264.881 169.851 C 264.808 169.842 264.734 169.828 264.661 169.811 L 264.225 169.709 C 264.151 169.692 264.079 169.671 264.009 169.647 C 263.936 169.637 263.862 169.624 263.789 169.607 L 263.353 169.505 C 263.279 169.488 263.207 169.467 263.137 169.443 C 263.064 169.433 262.99 169.42 262.917 169.403 L 262.481 169.301 C 262.407 169.283 262.335 169.263 262.265 169.239 C 262.192 169.229 262.118 169.216 262.045 169.198 L 261.827 169.147 C 260.61 168.863 259.855 167.646 260.14 166.43 Z",
    fill: "url(#paint2_linear_23336_66054)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 252.792 164.684 C 253.081 163.469 254.3 162.718 255.515 163.006 L 255.733 163.058 C 255.807 163.076 255.878 163.097 255.948 163.121 C 256.022 163.131 256.095 163.144 256.169 163.162 L 256.605 163.265 C 256.679 163.283 256.751 163.304 256.821 163.328 C 256.894 163.338 256.968 163.351 257.041 163.369 L 257.477 163.472 C 257.551 163.49 257.623 163.511 257.693 163.535 C 257.766 163.545 257.84 163.558 257.913 163.576 L 258.349 163.679 C 258.423 163.697 258.495 163.718 258.565 163.742 C 258.638 163.752 258.712 163.765 258.785 163.783 L 259.003 163.835 C 260.219 164.123 260.97 165.343 260.681 166.558 C 260.393 167.773 259.174 168.524 257.958 168.236 L 257.74 168.184 C 257.667 168.167 257.595 168.146 257.525 168.122 C 257.451 168.112 257.378 168.098 257.304 168.081 L 256.868 167.977 C 256.795 167.959 256.723 167.939 256.653 167.915 C 256.579 167.905 256.506 167.891 256.432 167.873 L 255.996 167.77 C 255.923 167.752 255.851 167.732 255.781 167.707 C 255.707 167.697 255.634 167.684 255.56 167.666 L 255.124 167.563 C 255.05 167.545 254.979 167.524 254.909 167.5 C 254.835 167.49 254.762 167.477 254.688 167.459 L 254.47 167.408 C 253.255 167.119 252.503 165.9 252.792 164.684 Z",
    fill: "url(#paint3_linear_23336_66054)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 245.441 162.965 C 245.726 161.748 246.942 160.993 248.158 161.278 L 248.376 161.329 C 248.45 161.346 248.522 161.367 248.592 161.391 C 248.665 161.401 248.739 161.414 248.813 161.431 L 249.249 161.533 C 249.322 161.551 249.394 161.571 249.464 161.595 C 249.537 161.605 249.611 161.618 249.685 161.635 L 250.121 161.738 C 250.194 161.755 250.266 161.775 250.336 161.799 C 250.41 161.809 250.483 161.822 250.557 161.84 L 250.993 161.942 C 251.066 161.959 251.138 161.979 251.208 162.003 C 251.282 162.013 251.355 162.027 251.429 162.044 L 251.647 162.095 C 252.863 162.379 253.618 163.596 253.333 164.813 C 253.049 166.029 251.832 166.784 250.616 166.499 L 250.398 166.448 C 250.324 166.431 250.252 166.41 250.182 166.386 C 250.109 166.377 250.035 166.363 249.962 166.346 L 249.525 166.244 C 249.452 166.227 249.38 166.206 249.31 166.182 C 249.237 166.172 249.163 166.159 249.089 166.142 L 248.653 166.04 C 248.58 166.023 248.508 166.002 248.438 165.978 C 248.365 165.968 248.291 165.955 248.217 165.938 L 247.781 165.836 C 247.708 165.818 247.636 165.798 247.566 165.774 C 247.492 165.764 247.419 165.751 247.345 165.734 L 247.127 165.682 C 245.911 165.398 245.156 164.181 245.441 162.965 Z",
    fill: "url(#paint4_linear_23336_66054)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23336_66054)",
    transform: "matrix(1, 0, 0, 1, 223.1892547607422, 129.0519256591797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7164 10.2783C26.6814 10.2083 26.6114 10.1733 26.5414 10.185C26.4948 10.2083 26.4598 10.2433 26.4364 10.2783L25.9348 11.0483C25.8414 10.045 26.4482 9.25163 26.4714 8.27163C26.4832 8.16663 26.4364 8.06163 26.3432 8.02663C26.2382 7.99163 26.1332 8.07331 26.0514 8.15497L25.1182 9.07663C24.9198 9.26331 24.7564 9.48497 24.6164 9.71831C24.1614 10.465 23.8232 11.34 23.8932 12.2033L21.3614 16.2983C21.2914 16.45 21.1164 16.5083 20.9648 16.4383L15.4814 14.2333L15.7031 18.165L21.0932 19.1684C22.2482 19.4834 23.0882 18.7134 23.5782 17.6284L25.9348 13.09L25.9464 13.1366C26.4014 12.32 26.6698 11.41 26.7398 10.4766C26.7514 10.4183 26.7398 10.3483 26.7164 10.2783Z",
    fill: "url(#paint5_linear_23336_66054)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 232.476 177.655 L 232.091 181.949 L 238.087 184.037 C 239.207 184.434 240.047 182.964 239.126 182.205 L 239.091 182.17 C 237.761 181.12 235.754 178.46 235.754 178.46",
    fill: "#727D79"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 238.169 177.142 L 238.32 181.202 L 244.189 182.439 C 245.285 182.672 245.892 181.19 244.935 180.595 L 244.889 180.572 C 243.524 179.744 240.724 177.48 240.724 177.48",
    fill: "#727D79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 224.928 155.197 C 224.928 155.197 224.718 160.75 228.474 162.769 C 232.231 164.799 232.056 178.962 232.056 178.962 L 236.373 178.962 L 236.373 167.225 C 236.373 166.187 236.128 165.16 235.661 164.239 L 232.896 158.79 L 237.131 165.23 L 237.936 178.577 L 241.786 178.11 L 241.786 165.557 C 241.786 163.294 240.993 161.112 239.546 159.374 L 234.564 153.4 L 224.928 155.197 Z",
    fill: "#D7D8D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 239.581 148.827 L 240.631 144.464 L 235.113 142.434 C 233.713 142.095 232.313 142.947 231.975 144.347 C 231.893 144.685 231.881 145.035 231.94 145.374 C 232.115 146.435 233.456 147.404 234.506 147.625 L 239.581 148.827 Z",
    fill: "#AC41D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 234.494 142.364 L 234.401 142.364 L 234.401 142.375 C 236.023 143.052 236.956 144.755 236.641 146.482 L 236.419 148.092 L 239.581 148.839 L 240.631 144.475 L 235.113 142.445 C 234.914 142.399 234.704 142.375 234.494 142.364 Z",
    fill: "url(#paint6_linear_23336_66054)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 229.687 142.154 L 233.584 143.81 L 235.217 140.882 L 236.232 140.859 C 237.037 140.777 236.921 139.879 236.886 139.307 C 236.862 138.864 236.839 138.42 236.804 137.977 C 236.967 138 237.177 138 237.259 137.86 C 237.294 137.755 237.294 137.65 237.247 137.557 C 237.049 136.845 236.792 136.145 236.501 135.48 C 236.174 134.769 235.731 133.754 234.856 133.719 C 233.841 133.684 232.884 134.127 231.974 134.594 C 231.122 135.025 230.737 135.854 230.679 136.787 C 230.656 137.23 230.714 137.674 230.854 138.094 C 231.052 138.479 231.274 138.84 231.519 139.202 L 229.687 142.154 Z",
    fill: "#8D5524"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 235.661 136.997 C 235.758 136.997 235.836 136.919 235.836 136.822 C 235.836 136.725 235.758 136.647 235.661 136.647 C 235.564 136.647 235.486 136.725 235.486 136.822 C 235.486 136.919 235.564 136.997 235.661 136.997 Z",
    fill: "#0E1010"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 233.713 136.67 C 233.76 136.25 234.063 135.912 234.471 135.83 C 234.88 135.714 235.3 135.714 235.708 135.62 C 235.988 135.55 236.256 135.434 236.501 135.27 C 236.7 135.142 236.875 134.979 237.015 134.78 C 237.388 134.22 237.376 133.474 236.98 132.925 C 236.595 132.389 236 132.12 235.37 132.319 C 234.705 132.517 234.215 133.065 233.643 133.462 C 233.165 133.8 232.616 134.034 232.033 134.15 C 231.485 134.267 230.901 134.279 230.435 134.582 C 230.19 134.745 229.98 134.967 229.84 135.235 C 229.373 136.005 229.291 136.985 229.49 137.872 C 229.688 138.759 230.213 140.007 231.321 139.995 C 231.811 139.984 232.255 139.715 232.5 139.284 C 232.196 139.132 231.881 138.98 231.706 138.7 C 231.555 138.455 231.496 138.164 231.543 137.884 C 231.566 137.674 231.648 137.475 231.776 137.324 C 232.091 136.95 232.64 136.904 233.013 137.219 C 233.095 137.289 233.153 137.359 233.211 137.452 C 233.246 137.522 233.293 137.592 233.363 137.639 C 233.456 137.674 233.573 137.627 233.62 137.534 C 233.666 137.44 233.69 137.347 233.69 137.242 C 233.666 137.044 233.678 136.857 233.713 136.67 Z",
    fill: "#000704"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 228.521 141.605 L 233.689 142.154 C 235.684 142.55 236.991 144.475 236.629 146.482 L 235.532 154.59 L 224.916 155.197 L 226.887 142.807 C 227.039 142.049 227.751 141.524 228.521 141.605 Z",
    fill: "#AC41D8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 224.974 154.929 L 224.928 155.197 L 225.079 155.185 C 225.044 155.104 225.009 155.01 224.974 154.929 Z M 234.716 148.395 C 234.669 148.395 234.611 148.395 234.564 148.384 L 234.343 148.36 C 233.584 148.279 233.048 147.602 233.129 146.844 L 233.328 145.059 C 233.339 144.907 233.468 144.79 233.619 144.79 L 233.643 144.79 L 236.011 145.059 C 236.174 145.082 236.291 145.222 236.279 145.385 L 236.081 147.159 C 235.999 147.859 235.404 148.384 234.716 148.395 Z M 228.358 141.594 C 228.264 141.594 228.171 141.605 228.078 141.617 C 229.349 141.804 230.294 142.9 230.294 144.184 C 230.294 144.277 230.294 144.37 230.283 144.464 L 229.758 149.854 L 228.754 149.725 L 228.369 153.144 C 228.334 153.459 228.486 153.762 228.754 153.937 L 230.341 154.894 L 235.533 154.602 L 236.629 146.494 C 236.991 144.487 235.684 142.562 233.689 142.165 L 229.933 141.769 L 228.521 141.617 C 228.474 141.617 228.416 141.617 228.369 141.617",
    fill: "url(#paint7_linear_23336_66054)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 233.187 159.817 L 226.222 156.434 C 225.254 155.862 224.717 154.777 224.834 153.657 L 225.569 144.604 L 228.532 145.28 C 228.941 145.374 229.209 145.759 229.162 146.167 L 228.392 153.12 C 228.357 153.435 228.509 153.739 228.777 153.914 L 234.727 157.542 L 233.187 159.817 Z",
    fill: "#8D5524"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 224.612 149.2 L 229.769 149.865 L 230.294 144.475 C 230.422 143.052 229.372 141.78 227.937 141.664 C 226.514 141.535 225.242 142.585 225.125 144.02 L 224.612 149.2 Z",
    fill: "#AC41D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 227.715 141.594 C 226.35 141.594 225.219 142.644 225.114 143.997 L 224.612 149.189 L 229.769 149.854 L 230.294 144.464 C 230.305 144.37 230.305 144.277 230.305 144.184 C 230.294 142.9 229.349 141.815 228.089 141.629 C 227.96 141.617 227.832 141.605 227.715 141.594 Z",
    fill: "url(#paint8_linear_23336_66054)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 232.464 156.142 C 233.35 156.119 234.237 156.189 235.112 156.329 C 235.31 156.375 235.52 156.422 235.73 156.457 C 235.847 156.48 236.092 156.457 236.197 156.527 C 236.594 156.83 235.835 156.994 235.637 157.052 C 235.31 157.145 234.715 157.297 234.949 157.74 C 235.229 158.254 235.824 158.37 236.337 158.51 C 236.71 158.604 237.784 158.86 237.69 159.42 C 237.632 159.759 237.014 160.062 236.745 160.214 C 235.089 161.124 233.397 160.132 232.055 159.14 C 231.752 158.919 231.449 158.72 231.169 158.475",
    fill: "#8D5524"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 235.229 140.894 L 233.642 140.894 L 234.692 141.839 L 235.229 140.894 Z",
    fill: "#6B2B09"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 236.466 138.327 L 235.498 138.129 C 235.498 138.129 235.638 138.712 236.011 138.782 C 236.373 138.864 236.466 138.327 236.466 138.327 Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 233.619 144.79 C 233.467 144.79 233.339 144.907 233.327 145.059 L 233.129 146.844 C 233.047 147.602 233.584 148.279 234.342 148.36 L 234.564 148.384 C 234.611 148.395 234.669 148.395 234.716 148.395 C 235.416 148.395 235.999 147.87 236.081 147.17 L 236.279 145.385 C 236.302 145.222 236.186 145.07 236.022 145.059 L 233.654 144.79 L 233.619 144.79 Z",
    fill: "url(#paint9_linear_23336_66054)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 248.541 139.855 C 248.506 139.785 248.436 139.75 248.366 139.762 C 248.32 139.785 248.285 139.82 248.261 139.855 L 247.76 140.625 C 247.666 139.622 248.273 138.829 248.296 137.849 C 248.308 137.744 248.261 137.639 248.168 137.604 C 248.063 137.569 247.958 137.65 247.876 137.732 L 246.943 138.654 C 246.745 138.84 246.581 139.062 246.441 139.295 C 245.986 140.042 245.648 140.917 245.718 141.78 L 243.186 145.875 C 243.116 146.027 242.941 146.085 242.79 146.015 L 240.491 145.222 L 239.675 148.139 L 242.895 148.769 C 244.05 149.084 244.89 148.314 245.38 147.229 L 247.736 142.69 L 247.748 142.737 C 248.203 141.92 248.471 141.01 248.541 140.077 C 248.565 139.995 248.565 139.925 248.541 139.855 Z",
    fill: "#8D5524"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDescontosExclusivos);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/descontos_exclusivos.d1f126148af11bfdb04c5d463e8d5d33.svg";